const stats = [
  { value: '6', label: 'Años de experiencia' },
  { value: '+50', label: 'Proyectos de diseño' },
  { value: '3', label: 'Construcciones ejecutadas' },
];

export default function About() {
  return (
    <section id="estudio" className="bg-white text-neutral-900 scroll-mt-20">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-16 items-start">
          <div className="lg:col-span-5 reveal">
            <div className="relative overflow-hidden bg-neutral-100">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20architecture%20studio%20workspace%20with%20large%20drafting%20table%2C%20rolled%20blueprints%20and%20architectural%20models%2C%20monochrome%20black%20and%20white%20photography%2C%20soft%20natural%20window%20light%2C%20clean%20geometric%20composition%2C%20premium%20editorial%20style%2C%20muted%20grey%20tones%2C%20negative%20space&width=1200&height=900&seq=am-studio-01&orientation=landscape"
                alt="Estudio de arquitectura y diseño AM Estudio en San Luis Potosí"
                className="w-full aspect-[4/3] object-cover object-top"
              />
              <span className="absolute top-4 left-4 w-12 h-12 border-t border-l border-white/50"></span>
              <span className="absolute bottom-4 right-4 w-12 h-12 border-b border-r border-white/50"></span>
            </div>
          </div>

          <div className="lg:col-span-7">
            <p className="overline text-neutral-400 reveal">Sobre AM Estudio</p>
            <h2 className="font-display font-medium tracking-tightest text-[clamp(2rem,5vw,4.5rem)] mt-4 reveal">
              Un estudio de diseño con enfoque integral
            </h2>

            <div className="mt-8 space-y-5 text-base md:text-lg text-neutral-600 leading-relaxed reveal">
              <p>
                Al frente de AM Estudio está{' '}
                <strong className="text-neutral-900 font-medium">
                  Omar Askander del Río Castillo
                </strong>
                , responsable de diseño. Egresado de la Universidad Cuauhtémoc y
                con diplomado en Neurodiseño.
              </p>
              <p>
                Buscamos crear espacios funcionales, estéticos y adaptados a las
                necesidades reales de cada cliente.
              </p>
              <p>
                Nuestro diferenciador es el acompañamiento cercano y
                personalizado, el entendimiento del contexto y del entorno, y la
                integración de inteligencia artificial en el diseño, la
                visualización y la gestión del proyecto.
              </p>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-6 reveal">
              {stats.map((s) => (
                <div key={s.label} className="border-t border-neutral-200 pt-5">
                  <p className="font-display text-4xl md:text-6xl font-medium tracking-tightest">
                    {s.value}
                  </p>
                  <p className="overline text-neutral-400 mt-3">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}